import {FC} from 'react';

interface Props {
  className?: string;
}

const RoyalCaninIcon: FC<Props> = ({className = ''}) => (
  <svg width="47" height="25" viewBox="0 0 47 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g id="Crown">
      <path
        id="Fill 28"
        d="M9.61414 22.4461C9.20346 22.4461 8.79609 22.2599 8.53112 21.9081C8.08486 21.3136 8.20653 20.4709 8.8033 20.026C12.3928 17.3555 17.8868 15.7599 23.4986 15.7599H23.4991C29.0902 15.7599 34.5702 17.3545 38.1581 20.026C38.7573 20.4709 38.8797 21.3124 38.4296 21.907C37.9859 22.5016 37.1378 22.6227 36.5386 22.1771C34.116 20.3748 29.4182 18.4487 23.5 18.4487H23.4986C17.5531 18.4487 12.8473 20.3748 10.423 22.1781C10.1816 22.3593 9.89743 22.4461 9.61414 22.4461Z"
        fill="#EC001A"
      />
      <path
        id="Fill 30"
        d="M10.8502 24.7427C10.5838 24.7427 10.3182 24.6277 10.1341 24.4071C9.81244 24.0148 9.86916 23.4353 10.2635 23.113C13.3674 20.5773 18.315 19.0638 23.5012 19.0638C28.6614 19.0638 33.595 20.5766 36.6994 23.1128C37.0947 23.4339 37.1531 24.0138 36.8287 24.4064C36.5041 24.7989 35.9212 24.8551 35.5269 24.5331C32.7412 22.2595 28.2463 20.9022 23.5012 20.9022C18.8031 20.9022 14.1786 22.2933 11.4379 24.5336C11.2667 24.6748 11.058 24.7427 10.8502 24.7427Z"
        fill="#EC001A"
      />
      <path
        id="Fill 32"
        d="M3.60565 5.3949C3.05551 5.3949 2.51157 5.54292 2.03498 5.82332C1.32322 6.2419 0.815426 6.91321 0.608378 7.71046C0.404694 8.50919 0.520116 9.33732 0.943299 10.045C1.49253 10.9677 2.50917 11.5474 3.59892 11.5574L3.62007 11.5587C4.17219 11.5582 4.71704 11.4098 5.19363 11.1284C5.90636 10.7095 6.41131 10.0399 6.61716 9.24311C6.82392 8.44563 6.70369 7.61631 6.28195 6.90839C5.72839 5.9744 4.70118 5.3949 3.60565 5.3949Z"
        fill="#EC001A"
      />
      <path
        id="Fill 34"
        d="M23.4817 7.76617C21.7706 7.76617 20.3779 9.14914 20.3779 10.8477C20.3779 12.5474 21.7706 13.9306 23.4817 13.9306C25.1909 13.9306 26.5803 12.5474 26.5803 10.8477C26.5803 9.14914 25.1909 7.76617 23.4817 7.76617Z"
        fill="#EC001A"
      />
      <path
        id="Fill 36"
        d="M23.4817 0.04776C21.7706 0.04776 20.3779 1.43077 20.3779 3.12932C20.3779 4.82906 21.7706 6.21178 23.4817 6.21178C25.1909 6.21178 26.5803 4.82906 26.5803 3.12932C26.5803 1.43077 25.1909 0.04776 23.4817 0.04776Z"
        fill="#EC001A"
      />
      <path
        id="Fill 39"
        d="M15.2343 8.84C14.9582 8.84 14.6822 8.87613 14.4141 8.9483C12.7638 9.39727 11.7886 11.0962 12.242 12.7353C12.6056 14.0568 13.8295 14.9894 15.2199 15.0028L15.2901 15.0043C15.5478 14.9995 15.8047 14.9626 16.0547 14.8948C16.8526 14.6782 17.5167 14.164 17.9284 13.4489C18.3381 12.7332 18.4429 11.9036 18.2246 11.11C17.8557 9.7726 16.627 8.84 15.2343 8.84Z"
        fill="#EC001A"
      />
      <path
        id="Fill 41"
        d="M7.55801 12.0387C7.00595 12.0387 6.46249 12.1864 5.9883 12.4673C5.27461 12.8852 4.76778 13.5563 4.56141 14.3538C4.35753 15.1522 4.47536 15.9818 4.89513 16.6906C5.44489 17.612 6.46152 18.191 7.5532 18.2015L7.57147 18.2024C8.12546 18.2024 8.66604 18.054 9.14599 17.7738C9.85823 17.3545 10.3646 16.6846 10.5686 15.8869C10.7753 15.0901 10.656 14.2613 10.2357 13.5522C9.67883 12.6189 8.6545 12.0387 7.55801 12.0387Z"
        fill="#EC001A"
      />
      <path
        id="Fill 43"
        d="M32.5457 8.94833C32.2776 8.87616 32.0037 8.84003 31.7281 8.84003C30.3359 8.84003 29.1067 9.77263 28.7392 11.11C28.2882 12.7485 29.2613 14.4458 30.9101 14.8948C31.1784 14.9675 31.4554 15.005 31.7305 15.005C33.1199 15.005 34.3515 14.071 34.7189 12.7353C35.1681 11.0963 34.1947 9.3973 32.5457 8.94833Z"
        fill="#EC001A"
      />
      <path
        id="Fill 45"
        d="M34.5928 1.50343C34.3252 1.43098 34.0532 1.39389 33.7753 1.39389C32.3825 1.39389 31.1557 2.32797 30.7868 3.66386C30.3357 5.30261 31.3125 7.00116 32.9591 7.44942C33.227 7.5223 33.503 7.55958 33.7772 7.55958C35.168 7.55958 36.3991 6.6256 36.7665 5.28995C37.2186 3.65043 36.2423 1.95241 34.5928 1.50343Z"
        fill="#EC001A"
      />
      <path
        id="Fill 47"
        d="M40.9743 12.4673C40.4967 12.1864 39.9521 12.0387 39.4003 12.0387C38.3081 12.0387 37.2844 12.6189 36.7292 13.5522C36.3077 14.2613 36.1885 15.0901 36.3945 15.8869C36.5985 16.6847 37.1054 17.3545 37.8171 17.7738C38.298 18.0545 38.8404 18.2025 39.3945 18.2025C40.4854 18.2025 41.5086 17.6235 42.0645 16.6906C42.4858 15.9818 42.6029 15.1522 42.3973 14.3538C42.191 13.5563 41.6846 12.8852 40.9743 12.4673Z"
        fill="#EC001A"
      />
      <path
        id="Fill 49"
        d="M46.3501 7.71046C46.1441 6.91321 45.6377 6.2419 44.925 5.82332C44.447 5.54292 43.9035 5.3949 43.3514 5.3949C42.2607 5.3949 41.2369 5.9744 40.6814 6.90795C40.2592 7.61698 40.1399 8.4463 40.3466 9.24311C40.5515 10.0399 41.0575 10.7095 41.7699 11.1284C42.2482 11.4104 42.7926 11.5587 43.3457 11.5587C44.4388 11.5587 45.4627 10.9792 46.0173 10.045C46.4384 9.33732 46.5568 8.50919 46.3501 7.71046Z"
        fill="#EC001A"
      />
      <path
        id="Fill 51"
        d="M13.1882 7.55961C13.4642 7.55961 13.7402 7.52205 14.0057 7.4494C15.6524 7.00119 16.6267 5.3026 16.1766 3.66384C15.8101 2.328 14.5794 1.39392 13.1852 1.39392C12.9097 1.39392 12.6332 1.43101 12.3668 1.50346C10.716 1.95244 9.74142 3.65046 10.1921 5.29041C10.5575 6.61267 11.7815 7.5448 13.1699 7.55818L13.1882 7.55961Z"
        fill="#EC001A"
      />
    </g>
  </svg>
);

export default RoyalCaninIcon;
